"use client";
import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

// Helper to fire fbq events safely
function fbqTrack(event, params) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", event, params);
  }
}

export default function MetaPixelEvents() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Track page view on route change
    fbqTrack("PageView");
  }, [pathname, searchParams]);

  return null;
}
